import React, { Component } from "react";
import logo from "./logo.svg";
import MainPage from "./MainPage";
import firebase from "./firebase/firebase";
import { useAsync } from "react-async";
import SignInScreen from "./SignInScreen";
import { createAccount, createUser } from "./dao/auth";
import { isValidEmail } from "./utils";

class SignUpScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullname: "",
      email: "",
      pwd: "",
      repwd: "",
      error: false,
      errorMsg: "",
      authorized: false,
      login: false,
      loading: false,
    };

    this.onSignUp = this.onSignUp.bind(this);
    this.onChange = this.onChange.bind(this);
    console.log("signup ", this.props);
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      error: false,
      loading: false,
    });
  }

  async onSignUp() {
    /** Checks for errors in form */
    let error = false;
    let errorMsg = "";
    if (this.state.fullname === "") {
      error = true;
      errorMsg = "full name";
    } else if (this.state.email === "") {
      error = true;
      errorMsg = "email";
    } else if (!isValidEmail(this.state.email)) {
      error = true;
      errorMsg = "invalid email address";
    } else if (this.state.pwd === "" || this.state.pwd !== this.state.repwd) {
      error = true;
      errorMsg = "password";
    }

    const fs = firebase.firestore();
    if (error) {
      this.setState({
        error: error,
        errorMsg: errorMsg,
      });
    } else {
      this.setState({
        loading: true,
      });
      let error = false;
      let addUser = false;
      // check if account exists
      const checking = await fs
        .collection("users")
        .doc(this.state.email)
        .get()
        .then((doc) => {
          if (typeof doc.data() === "undefined") {
            addUser = true;
          } else {
            console.log("account is already existed");
            error = true;
            this.setState({
              error: true,
              errorMsg: "An account is already existed with this email",
            });
          }
        })
        .catch((error) => {
          error = true;
          this.setState({
            error: true,
            errorMsg: "unable to create a new account, please try again",
          });
        });

      if (!error && addUser) {
        createAccount(this.state.email, this.state.pwd, (resp) => {
          if (resp.data) {
            const dt = new Date().getDate();
            const addNewUser = {
              FullName: this.state.fullname,
              LastLogin: null,
              CreatedOn: JSON.stringify(Date()),
            };
            createUser(this.state.email, addNewUser, (resp) => {
              console.log("create user ", resp);
              if (resp.login) {
                console.log("successfully added a new user ");
                this.setState({
                  login: true,
                });
                this.props.appProps2.handleUpdateState(
                  this.state.fullname,
                  this.state.email,
                  true
                );
                this.setState({
                  loading: false,
                  errorMsg: "",
                });
              } else {
                console.log("error creating user ", resp.errorMsg);
                this.setState({
                  loading: false,
                  errorMsg: resp.errorMsg,
                });
              }
            });
          } else {
            console.log("error creating auth ", resp.error.message);
            this.setState({
              loading: false,
              errorMsg: resp.error.message,
            });
          }
        });
      }
    }
  }

  render() {
    if (this.props.appProps2.state.signIn) {
      return <SignInScreen appProps={this.props.appProps2} resetChild="" />;
    }
    return (
      <div>
        <div
          class="container p-0 my-5 border glassmorph"
          style={{ maxWidth: "500px" }}
        >
          <div class="container p-2 text-center gradientTop">
            <h3>Sign Up</h3>
            <hr className="w-75"></hr>
          </div>

          {/** Form for sign up */}
          <div class="container p-3">
            <div class="form-group">
              <label for="usr">Full Name</label>
              <input
                type="text"
                class="form-control shadow-none"
                name="fullname"
                value={this.state.fullname}
                onChange={this.onChange}
              />
            </div>

            <div class="form-group">
              <label for="usr">Email</label>
              <input
                type="email"
                class="form-control shadow-none"
                name="email"
                value={this.state.email}
                onChange={this.onChange}
              />
            </div>

            <div class="form-group">
              <label for="pwd">Password</label>
              <input
                type="password"
                class="form-control shadow-none"
                name="pwd"
                value={this.state.pwd}
                onChange={this.onChange}
              />
            </div>

            <div class="form-group">
              <label for="pwd">Re-enter Password</label>
              <input
                type="password"
                class="form-control shadow-none "
                name="repwd"
                value={this.state.repwd}
                onChange={this.onChange}
              />
            </div>

            <div class="form-group">
              <br />
              {this.state.loading ? (
                <button
                  disabled
                  type="button"
                  onClick={this.onSignUp}
                  class="btn btn-secondary btn-block"
                >
                  <span class="spinner-border spinner-border-sm"> </span>
                  &nbsp;Sign Up...
                </button>
              ) : (
                <button
                  type="button"
                  onClick={this.onSignUp}
                  class="btn btn-secondary btn-block"
                >
                  Sign Up
                </button>
              )}
            </div>
            {/** Error display */}
            {this.state.error ? (
              <div class="alert alert-danger text-center">
                <strong>Invalid!</strong> {this.state.errorMsg}
              </div>
            ) : (
              <div>
                <br />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SignUpScreen;
